import { BatchLevelState } from "./batchLevel.types";

export const state: BatchLevelState = {
  batchLevels: [],
  batchLevel: null,
  loading: false,
  pagination: null
};
